<template>
    <div id="cb-entities">
        <div class="content">
            <div class="entities-container">
                <div class="header">
                    <div class="left">
                        <div class="title">{{ $t("chatbotv2.entities") }}</div>
                        <div
                            @click="createModal = true"
                            class="icon-container"
                            v-if="checkPermission(PERMISSION_TYPES['chatbot.entities.create'].tr.name)"
                        >
                            <md-icon>add</md-icon>
                        </div>
                    </div>
                    <div class="right">
                        <div class="input-container" tabindex="0">
                            <input :placeholder="$t('visitor.search')" v-model="search" />
                            <md-icon>search</md-icon>
                        </div>
                    </div>
                </div>
                <div class="entities">
                    <div class="entities-list-wrapper">
                        <div
                            class="entities-list-item"
                            v-for="(entitie, index) in search ? searchArray : entities"
                            :key="entitie.name"
                            @click="updateModal = entitie._id"
                        >
                            <div class="name">
                                {{ entitie.name }}
                            </div>
                            <div
                                class="delete-icon"
                                @click="(e) => deleteButtonClickHandler(e, entitie._id)"
                                v-if="checkPermission(PERMISSION_TYPES['chatbot.entities.delete'].tr.name)"
                            >
                                <md-icon>delete_outline</md-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EntriesForm v-if="createModal" @cancel="createModal = false" />
        <EntriesForm v-if="updateModal" @cancel="updateModal = false" :id="updateModal" />
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar";
import { mapActions, mapGetters, mapState } from "vuex";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import ChatbotMenu from "../../ChatbotMenu.vue";
import EntriesForm from "./Entries.vue";

export default {
    name: "Entries",
    computed: {
        ...mapState({
            entities: (state) => state.CB.userEntities,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
    },
    components: {
        ChatbotMenu,
        SideMenuBar,
        EntriesForm,
    },
    data() {
        return {
            search: "",
            searchArray: [],
            createModal: false,
            updateModal: false,
        };
    },
    methods: {
        ...mapActions({
            fetchUserEntities: "CB/fetchUserEntities",
            deleteUserEntities: "CB/deleteUserEntities",
        }),
        deleteButtonClickHandler(event, id) {
            event.stopPropagation();
            this.deleteUserEntities(id);
        },
    },
    async mounted() {
        this.fetchUserEntities();
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.entities.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        search: {
            handler(newValue, oldValue) {
                const filteredEntities = this.entities.filter((entity) => {
                    return entity.name.toLowerCase().includes(newValue.toLowerCase());
                });
                this.searchArray = filteredEntities;
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#cb-entities {
    display: flex;
    height: auto;
    display: flex;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        height: 100%;
    }

    .entities-container {
        width: 100%;
        padding: 0 30px;
        margin-top: 20px;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left {
                display: flex;
                justify-content: center;
                align-items: center;

                .title {
                    color: #22272d;
                    font-weight: 500;
                    line-height: 31px;
                    font-size: 24px;
                }

                .icon-container {
                    background-color: #008aff;
                    border-radius: 9999px;
                    padding: 3px;
                    margin-left: 15px;
                    cursor: pointer;
                    transition: 0.3s;

                    i {
                        font-size: 20px;
                        color: #fff;
                    }

                    &:hover {
                        opacity: 0.8 !important;
                    }
                }
            }

            .right {
                width: 300px;

                .input-container {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    position: relative;

                    input {
                        width: 100%;
                        outline: none;
                        height: 40px;
                        color: #22272d;
                        border: 1px solid #c6cdd4;
                        border-radius: 6px;
                        padding: 9px 35px 9px 17px;
                        font-size: 14px;
                        line-height: 20px;

                        &::placeholder {
                            color: #c6cdd4;
                        }

                        &::-ms-input-placeholder {
                            color: #c6cdd4;
                        }

                        &:focus {
                            border-color: #006cff;

                            & ~ i {
                                color: #006cff;
                            }
                        }
                    }

                    i {
                        position: absolute;
                        right: 5px;
                        top: 7px;
                        color: #c6cdd4;
                    }
                }
            }
        }

        .entities {
            max-width: 600px;

            .entities-list-wrapper {
                width: 100%;
                margin-top: 30px;

                .entities-list-item {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #c6cdd4;
                    cursor: pointer;

                    .name {
                        color: #516173;
                        font-size: 16px;
                        line-height: 20px;
                    }

                    .delete-icon {
                        user-select: none;
                        transition: all 0.3s;

                        i {
                            color: #516173;
                            font-size: 20px;
                            padding: 4px;
                            opacity: 0;
                        }
                    }

                    &:hover {
                        .name {
                            opacity: 0.8 !important;
                        }

                        .delete-icon {
                            i {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
